/**
 * 株主番号入力画面（ShareholderSurvey）への遷移先ルートを組み立てる
 * @param {Object} bookGroup
 * @param {Object} masterBook
 * @returns {Object} vue-router の router.push に渡すルートオブジェクト
 */
export const buildShareholderSurveyRoute = (bookGroup, masterBook) => ({
  name: "ShareholderSurvey",
  params: {
    book_group_id: bookGroup.id,
    master_book_id: masterBook.id,
    master_survey_id: bookGroup.master_survey_id,
  },
  query: {
    voucher: true,
  },
});
